/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultReviewCard from "examples/Cards/ReviewCards/DefaultReviewCard";

// Images
import appleLogo from "assets/images/logok.png";
import facebookLogo from "assets/images/sampra.png";
import nasaLogo from "assets/images/risas.png";
import vodafoneLogo from "assets/images/sambros.png";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          justifyContent="center"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2">Meet the Team</MKTypography>
          <MKTypography variant="body1" color="text" mb={2}>
            Brought to you by our family of highly-trained and versatile musicians.
          </MKTypography>
        </Grid>
        <Grid container spacing={6} sx={{ mt: 8 }}>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Onzlo Juan Williams"
              review="Tracking, Editing, Mixing, Mastering, Electric Guitar and Vocals"
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="warning"
              name="Enzo Vaughn Williams"
              review="Drums, Percussion, Synthesizers, Programming, Arranging and Vocals"
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              name="Paul Edward Williams"
              review="Bass Guitar, Piano, Keyboards, Acoustic and Electric Guitar, Songwriting and Vocals"
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard
              color="warning"
              name="Cheryl Samantha Williams"
              review="Vocals and Songwriting"
              rating={5}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard name="Lanzar Romao Williams" review="Backing Vocals" rating={5} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <DefaultReviewCard color="warning" name="DJ E" review="Rap on 'Covererd'" rating={5} />
          </Grid>
        </Grid>
        <Divider sx={{ my: 6 }} />
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={appleLogo} alt="Apple" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={facebookLogo} alt="Facebook" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={nasaLogo} alt="Nasa" width="100%" opacity={0.6} />
          </Grid>
          <Grid item xs={6} md={4} lg={2}>
            <MKBox component="img" src={vodafoneLogo} alt="Vodafone" width="100%" opacity={0.6} />
          </Grid>
          {/* <Grid item xs={6} md={4} lg={2}>
          </Grid> */}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
